import React from 'react';
import { RunReportPage } from '../components/map/components/simulation-results/report/RunReportPage';

export default function SimulationReportPage() {
  return <RunReportPage />;
}
